import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { DescuentosService } from '../../http/apiPricing/descuentos.service';
import { IBundle } from '../../interfaces/shared/bundle/IBundle';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { StatusService } from '../status/status.service';

export interface Discount {
  value: number;
}

@Injectable({
  providedIn: 'root'
})
export class DiscountService {

  private discountSubject = new BehaviorSubject<Discount[]>([{ value: 0 }]);
  public discountSource: Observable<any> = this.discountSubject.asObservable();

  constructor(
    private descuentoService: DescuentosService,
    private sessionStorageService: SessionStorageService
  ) {
    this.Discount = this.sessionStorageService.get('discount') as Discount[];
  }

  set Discount(discount: Discount[]) {
    this.discountSubject.next(discount);
    this.sessionStorageService.set('discount', discount);
  }

  get Discount(): Discount[] {
    return this.discountSubject.getValue();
  }

  addDiscount(bundle: IBundle[]): void {
    const objectsInCart = bundle.length > 0 ? bundle.length : 0;
    this.descuentoService.totalDescuento(objectsInCart).pipe(
      map(data => ({ value: data } as Discount))
    ).subscribe((newDiscount: Discount) => {
      this.Discount = this.Discount.concat(newDiscount);
    });
  }

  updateTotalDiscount(bundle: IBundle[]): Observable<Discount[]> {
    const bindingCalls = bundle.map((_, index) =>
      this.descuentoService.totalDescuento(index + 1)
    );

    return forkJoin(bindingCalls).pipe(
      map(data =>
        data.reduce((acc, cur) => [...acc, ({ value: cur } as Discount)], [] as Discount[])),
      tap({
        next: newDiscounts => console.log('response', newDiscounts)
      }));
  }

  calculateDiscount(value: number, discount: number) {
    const result = value - (value * (discount / 100));
    return result.toFixed(2);
  }
}
